export default "__VITE_ASSET__Xj8Qseg8__"